<mat-dialog-content class="d-flex flex-col">

    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0">All Notifications</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button class="mat-dialog-close " mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="d-flex flex-col justify-content-center">
        <ng-container *ngFor="let notification of notifications; trackBy: trackByNotificationId">
            <div class="d-flex flex-col py-10 gap-10 w-100">
                <div class="flex-row flex-space-between">
                    <div (click)="this.notificationRedirect(notification)" class="flex-grow clickable">
                        <h4 class="m-0">{{ notification.title }}</h4>
                        <small class="notificationDate">{{ notification.created_at | relativeTime }}</small>
                    </div>
                    <div>
                        <a (click)="markNotificationAsRead(notification)" *ngIf="!notification.is_read"
                           class="clickable"
                           matTooltip="Mark notification as read">
                            <mat-icon>clear</mat-icon>
                        </a>
                    </div>
                </div>
                <p (click)="this.notificationRedirect(notification)"
                   class="m-0 notificationContent clickable">{{ notification.content }}</p>
            </div>
            <mat-divider></mat-divider>
        </ng-container>
        <ng-container *ngIf="!notifications.length">
            <div class="p-15">
                You have no new notifications
            </div>
        </ng-container>
    </div>
</mat-dialog-content>

